import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../Icon";
import { SERVICE_ITEMS } from "../data";
import { CONSULTING_SERVICE, FUNDING, MESSAGES, SERVICES_HUB, TECH_SERVICES, WEBSITE_SERVICE } from "../content";
import { CtaBand, PageHero, SectionHead, useSeo } from "../ui";

/* 서비스별 카드에 붙는 한 줄 — 각 서비스 페이지의 대표 문구를 그대로 쓴다 */
const SUMMARY = {
  "/partnership": { icon: "Rocket", text: MESSAGES.main },
  "/services/website": { icon: "Globe", text: WEBSITE_SERVICE.headline, badge: WEBSITE_SERVICE.price },
  "/services/consulting": { icon: "Doc", text: CONSULTING_SERVICE.headline },
  "/funding": { icon: "Award", text: FUNDING.headline },
};

export default function Services() {
  useSeo({
    title: "서비스 — 제품개발 · 회로 · PCB 설계 · 펌웨어 · 시제품 제작 · 웹사이트 개발 | I.META 아이닷메타",
    description:
      "I.META 서비스. 아이디어를 시제품부터 양산까지 함께 만드는 제품개발 서비스, 자영업자 홈페이지를 빠르게 구축하는 웹사이트 개발 서비스(기본료 20만원부터), 개발 컨설팅을 제공하는 개발지원 서비스, 창업·시제품 지원사업 기술 파트를 함께 준비하는 정부지원사업 연계. 회로 · PCB 설계, 임베디드 펌웨어, 전자제품 시제품 제작, ESP32 · IoT, 계측 · 제어 장치 개발.",
    path: "/services",
  });

  return (
    <>
      <PageHero kicker="SERVICES" title={SERVICES_HUB.title} desc={SERVICES_HUB.lead} />

      <section className="section section--tight">
        <div className="svc-cards">
          {SERVICE_ITEMS.map((s) => {
            const sum = SUMMARY[s.to] || {};
            const I = Icon[sum.icon];
            return (
              <Link key={s.to} to={s.to} className="svc-card">
                <div className="card__icon">
                  {I ? <I width="22" height="22" aria-hidden="true" focusable="false" /> : null}
                </div>
                <h2 className="svc-card__title">{s.label}</h2>
                <p className="svc-card__desc">{s.desc}</p>
                {sum.text && <p className="svc-card__text">{sum.text}</p>}
                {sum.badge && <span className="svc-card__badge">{sum.badge}</span>}
                <span className="card__more">
                  자세히 <Icon.ArrowRight width="14" height="14" aria-hidden="true" focusable="false" />
                </span>
              </Link>
            );
          })}
        </div>
      </section>

      {/* 개발 분야별 안내 — 분야 이름으로 찾아오는 분들을 위한 페이지 */}
      <section className="section">
        <SectionHead kicker="FIELDS" title="개발 분야" desc="회로부터 서버까지 한 팀에서 개발합니다. 분야별로 하는 일과 사례를 정리했습니다." />
        <div className="svc-cards">
          {TECH_SERVICES.map((t) => {
            const I = Icon[t.icon];
            return (
              <Link key={t.slug} to={`/services/${t.slug}`} className="svc-card">
                <div className="card__icon">
                  {I ? <I width="22" height="22" aria-hidden="true" focusable="false" /> : null}
                </div>
                <h3 className="svc-card__title">{t.label}</h3>
                <p className="svc-card__desc">{t.desc}</p>
                <p className="svc-card__text">{t.headline}</p>
                <span className="card__more">
                  자세히 <Icon.ArrowRight width="14" height="14" aria-hidden="true" focusable="false" />
                </span>
              </Link>
            );
          })}
        </div>
      </section>

      <CtaBand />
    </>
  );
}
